<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('ssbt.ssbt')}}</div>
            <router-link to="/onlineService" tag="div"><img class="icon" src="@/assets/new3/kefu2.png" alt=""></router-link>
        </div>
        <div class="cotainer">
          <div class="tips">{{$t('ssbt.ssnhm')}}</div>
          <div class="input-box"><input class="input" type="text" :disabled="status == 20" v-model="ssn" :placeholder="$t('ssbt.qsrssnhm')"></div>
          <div class="tips">{{$t('ssbt.idzmz')}}</div>
          <div class="upload-box">
            <template v-if="status == 20">
              <img v-if="idImg" class="upload" :src="idImg" alt="">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="">
            </template>
            <template v-else>
              <img v-if="idImg" class="upload" :src="idImg" alt="" @click="upload(1)">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="" @click="upload(1)">
            </template>
          </div>
          <div class="tips">{{$t('ssbt.dhfb')}}</div>
          <div class="upload-box">
            <template v-if="status == 20">
              <img v-if="dhImg1" class="upload" :src="dhImg1" alt="">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="">
              <img v-if="dhImg2" class="upload" :src="dhImg2" alt="">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="">
            </template>
            <template v-else>
              <img v-if="dhImg1" class="upload" :src="dhImg1" alt="" @click="upload(2)">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="" @click="upload(2)">
              <img v-if="dhImg2" class="upload" :src="dhImg2" alt="" @click="upload(3)">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="" @click="upload(3)">
            </template>
          </div>
          <div class="tips">{{$t('ssbt.srlyfb')}}</div>
           <div class="upload-box">
            <template v-if="status == 20">
              <img v-if="srImg1" class="upload" :src="srImg1" alt="">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="">
              <img v-if="srImg2" class="upload" :src="srImg2" alt="">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="">
            </template>
            <template v-else>
              <img v-if="srImg1" class="upload" :src="srImg1" alt="" @click="upload(4)">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="" @click="upload(4)">
              <img v-if="srImg2" class="upload" :src="srImg2" alt="" @click="upload(5)">
              <img v-else class="upload" src="@/assets/btn-upload.png" alt="" @click="upload(5)">
            </template>
          </div>
          <div class="cont" v-html="content"></div>
        </div>
        <div class="btn-sure" v-if="status == 20">{{$t('c2c.dsh')}}</div>
        <div class="btn-sure" v-else @click="sure">{{$t('c2c.tj')}}</div>
        <loading v-show="isLoad"></loading>
        <input class="___input" type="file" ref="foreheadCir" mutiple="mutiple" accept="image/*" style="display: none;">
    </div>
</template>

<script>
import loading from '@/components/loading.vue'
import lrz from "lrz";
export default {
    name: 'taxSubsidies',
    data () {
        return {
          token: '',
          ssn: '',
          idImg: '',
          dhImg1: '',
          dhImg2: '',
          srImg1: '',
          srImg2: '',
          uploadId: 1,
          isLoad: false,
          id: '',
          status: 0,//20待审核 30取消 40驳回 50通过
          content: '',
          count: 1
        }
    },
    created(){
      this.token = localStorage.getItem('token') || '';
    },
    mounted() {
      this.getTaxsubsidyList();
      this.getCont();
    },
    methods: {
      back(){
        this.$router.push('/index')
      },
      link(){
        this.$router.push('/onlineService')
      },
      getCont(){
        let params = {
          type: 'taxsubsidy'
        }
        this.$ajax.post('/web/getTextsList',params).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 0){
              this.content = this.contHtml(resData.content);
            }
        }).catch(function(err){
            console.log(err);
        })
      },
      contHtml(str){
          str = str.replace(/&amp;/g, '&');
          str = str.replace(/&lt;/g, '<');
          str = str.replace(/&gt;/g, '>');
          str = str.replace(/&quot;/g, "''");
          str = str.replace(/&#039;/g, "'");
          return str;
      },
      getTaxsubsidyList(){
        this.$ajax.get('/Web/getTaxsubsidyList').then((res) => {
            let resData = res.data.data.data;
            if(resData.length > 0){
              if(resData[0].status != 50){
                this.ssn = resData[0].ssn;
                this.idImg = resData[0].photo_front;
                this.dhImg1 = resData[0].wire_transfer_1;
                this.dhImg2 = resData[0].wire_transfer_2;
                this.srImg1 = resData[0].income_source_1;
                this.srImg2 = resData[0].income_source_2;
              }else{
                this.ssn = '';
                this.idImg = '';
                this.dhImg1 = '';
                this.dhImg2 = '';
                this.srImg1 = '';
                this.srImg2 ='';
              }
              this.id = resData[0].id;
              this.status = resData[0].status;
            }else{
              this.ssn = '';
              this.idImg = '';
              this.dhImg1 = '';
              this.dhImg2 = '';
              this.srImg1 = '';
              this.srImg2 ='';
              this.status = 0;
              this.id = '';
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      sure(){
        var url,params;
        if(this.ssn == '' || this.ssn == null){
          this.$toast.center(this.$t('ssbt.qsrssnhm'));
          return;
        }
        if(this.idImg == '' || this.idImg == null){
          this.$toast.center(this.$t('ssbt.qscidzmz'));
          return;
        }
        if(this.dhImg1 == '' && this.dhImg2 == ''){
          this.$toast.center(this.$t('ssbt.qscdhfb'));
          return;
        }
        if(this.srImg1 == '' && this.srImg2 == ''){
          this.$toast.center(this.$t('ssbt.qscsrlyfb'));
          return;
        }
        if(this.status == 30 || this.status == 40){//编辑
          url = '/web/editTaxsubsidy';
          params = {
            id: this.id,
            ssn: this.ssn,
            photo_front: this.idImg,
            wire_transfer_1: this.dhImg1,
            wire_transfer_2: this.dhImg2,
            income_source_1: this.srImg1,
            income_source_2: this.srImg2,
        }
        }else{//添加
          url = '/web/addTaxsubsidy';
          params = {
            ssn: this.ssn,
            photo_front: this.idImg,
            wire_transfer_1: this.dhImg1,
            wire_transfer_2: this.dhImg2,
            income_source_1: this.srImg1,
            income_source_2: this.srImg2,
          }
        }
        if(this.count == 1){
          this.count = 0;
        }else{
            return false;
        }
        this.$ajax.post(url,params).then((res) => {
          let resData = res.data;
          if(resData.code == 0 || resData.code == 4 || resData.code == 7){
              this.$toast.center(this.$t('status.statusText')[2]);
              setTimeout(() => {
                this.count = 1;
                this.$router.push('/index')
              }, 1000)
          }else{
            this.count = 1;
            this.$toast.center(resData.message);
            return;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      upload(id){
          var that = this;
          that.uploadId = id;
          this.uploadimg(function (res) {

          })
      },
      uploadimg(callback){
			    let that = this;
			    that.ele_input(function(res) {
            if (res.length > 0) {
              var formdata = new FormData();
              for (var i = 0, len = res.length; i < len; i++) {
                lrz(res[0]).then(function (rst) {
                  var formdata = new FormData();
                  let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                  formdata.append('file', file);
                  formdata.append('token', that.token);
                  formdata.append('app', 'h5');
                  that.isLoad = true;
                  $.ajax({
                    url: that.domain + "/web/uploadImg",
                    type: "POST",
                    data: formdata,
                    cache: false,
                    processData: false,
                    contentType: false,
                    success: function(data) {
                      if (typeof data == 'string') data = JSON.parse(data.data)
                      if (data && data.code == 0) {
                        that.isLoad = false;
                        if(that.uploadId == 1){
                          that.idImg = data.data.url;
                        }else if(that.uploadId == 2){
                          that.dhImg1 = data.data.url;
                        }else if(that.uploadId == 3){
                          that.dhImg2 = data.data.url;
                        }else if(that.uploadId == 4){
                          that.srImg1 = data.data.url;
                        }else if(that.uploadId == 5){
                          that.srImg2 = data.data.url;
                        }
                      }else{
                        that.isLoad = false;
                        that.$toast.center(data.message);
                        return;
                      }
                    },error: function(data) {
                      that.isLoad = false;
                      that.$toast.center(data.message);
                      return;
                    }
                  });
                })
              }
            }
			  })
		  },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
        }
        inputs.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        inputs.click();
      },
      hideLoad(){
          this.isLoad = false;
      },
      keyMoney(){
          this.number = this.number.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.number = this.number.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.number = this.number.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.number = this.number.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.number.indexOf(".") < 0 && this.number != "") { //首位是0的话去掉
              this.number = parseFloat(this.number);
          }
      },
    },
    components:{
		  loading
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
  .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        padding: 0 .3rem;
        color: #fff;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .3rem;
        margin-top: -.3rem;
    }
    .head .icon{
      position: absolute;
      right: .24rem;
      top: 50%;
      width: .68rem;
      transform: translateY(-50%);
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
      position: absolute;
      top: 1.2rem;
      bottom: 2.4rem;
      width: 100%;
      background: transparent;
      overflow-y: scroll;
    }
    .tips{
      padding: .6rem .48rem .5rem;
      color: #fff;
      font-size: .48rem;
    }
    .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 .34rem;
      padding: 0 .54rem;
      height: 1.3rem;
      background: rgba(26,36,63,.4);
      border-radius: 0.15rem;
    }
    .input-box .input::placeholder{
      color: #d2d2d2;
      font-size: .42rem;
    }
    .input-box .input{
      flex: 1;
      height: 1.3rem;
      color: #fff;
      font-size: .42rem;
      line-height: 1.3rem;
    }
    .upload-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 .48rem;
    }
    .upload{
      width: 4rem;
      height: 2.6rem;
      opacity: .8;
      border-radius: 0.3rem;
    }
    .cont{
      padding: .48rem;
      color: #fff;
      font-size: .45rem;
    }
    .btn-sure{
      position: absolute;
      left: .48rem;
      right: .48rem;
      bottom: 0;
      height: 1.28rem;
      margin: .5rem 0 .6rem;
      color: #fff;
      font-size: .56rem;
      line-height: 1.28rem;
      background-color: #0060ff;
      border-radius: 0.2rem;
      text-align: center;
    }

</style>



// WEBPACK FOOTER //
// src/pages/taxSubsidies.vue